import axios from 'axios';

/**
 * Reports skill usage to the Rigstate Cloud.
 */
export async function trackSkillUsage(
    apiUrl: string,
    apiKey: string,
    projectId: string,
    skillId: string
) {
    try {
        await axios.post(`${apiUrl}/api/v1/skills/usage`, {
            projectId,
            skillName: skillId,
            status: 'ACTIVATED'
        }, {
            headers: { 'x-api-key': apiKey }
        });
    } catch (e) {
        // Silhouette feedback failure - do not interrupt user
    }
}
